import React, { ComponentProps } from "react";

function PersonIconAlt({ fill, ...restProps }: ComponentProps<"svg">) {
  return (
    <svg
      width={22}
      height={23}
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M2.87193 22.4642H19.1068C20.4782 22.4642 21.2964 21.8145 21.2964 20.7359C21.2964 17.5967 17.3158 13.2793 10.9832 13.2793C4.66286 13.2793 0.680054 17.5967 0.680054 20.7359C0.680054 21.8145 1.50048 22.4642 2.87193 22.4642ZM10.9932 11.1129C13.6527 11.1129 15.9155 8.74817 15.9155 5.69121C15.9155 2.69061 13.6461 0.407227 10.9932 0.407227C8.34041 0.407227 6.06873 2.73283 6.07312 5.71342C6.07532 8.74817 8.32601 11.1129 10.9932 11.1129Z"
        fill={fill || "#CF7E21"}
      />
    </svg>
  );
}

export default PersonIconAlt;
